// Get the modal
var modal = document.getElementById('myModal');

// Get the button that opens the modal
var btn = document.getElementById('open-modal');

// Get the <span> element that closes the modal
var span = document.getElementsByClassName('close')[0];

var spanSuccess = document.getElementsByClassName('close')[1];

var modalButton = document.getElementById('close-modal-button');

var closeFlash = document.getElementById('flash-close');

var flashNotice = document.getElementById('notice-flash');

var primaryContent = document.getElementById('primary-modal-content');

var secondaryContent = document.getElementById('secondary-modal-content');

if (btn) {
  btn.onclick = function() {
    var accountingFirmId = btn.getAttribute('data-accounting_firm_id');
    modal.style.display = 'block';
    GustoAnalytics.track({
      eventCategory: 'PartnerDirectoryProfileEvent',
      eventName: 'InquiryModalOpen',
      accountingFirmId: accountingFirmId,
    });
  };
}

if (span) {
  span.onclick = function() {
    modal.style.display = 'none';
    GustoAnalytics.track({
      eventCategory: 'PartnerDirectoryProfileEvent',
      eventName: 'InquiryModalClose',
    });
  };
}

if (spanSuccess) {
  spanSuccess.onclick = function() {
    modal.style.display = 'none';
  };
}

if (modalButton) {
  modalButton.onclick = function() {
    secondaryContent.style.display = 'none';
    primaryContent.style.display = 'block';
    GustoAnalytics.track({
      eventCategory: 'PartnerDirectoryProfileEvent',
      eventName: 'ResubmitInquiry',
    });
  };
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = 'none';
    GustoAnalytics.track({
      eventCategory: 'PartnerDirectoryProfileEvent',
      eventName: 'InquiryModalClose',
    });
  }
};
